export default __webpack_public_path__ + "static/media/emotionsEvolution.8069cbb0.png";